(() => {
  const applyPageLayout = () => {
    const variables = getComputedStyle(document.documentElement);
    document.body.toggleAttribute('data-page-background', variables.getPropertyValue('--page-background-enabled').trim() === '1');
    document.body.toggleAttribute('data-page-constrain-width', variables.getPropertyValue('--page-constrain-width').trim() === '1');
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyPageLayout, { once: true });
  } else applyPageLayout();

  for (const event of ['shopify:section:load', 'shopify:section:unload']) {
    document.addEventListener(event, () => requestAnimationFrame(applyPageLayout));
  }
})();

// Restore cart after invoice payment attempt
document.addEventListener('DOMContentLoaded', function () {
  const invoiceActive = localStorage.getItem('invoice_cart_active');
  const savedItems = JSON.parse(localStorage.getItem('invoice_cart_restore') || '[]');

  if (!invoiceActive || savedItems.length === 0) return;

  fetch('/cart/clear.js')
    .then(() => {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: savedItems })
      });
    })
    .then(() => {
      localStorage.removeItem('invoice_cart_active');
      localStorage.removeItem('invoice_cart_restore');
      location.reload(); // optional: update cart display
    });

  console.log("Restore!");
});

if (document.querySelector('.product-personalization')) {
  /** Disable cart buttons when personalized product first loads */
  const cartButton = document.querySelector('.product-form__submit');
  const stickyCartButton = document.querySelector('product-sticky-form button[type="submit"]');

  const disableCartButton = b => {
    b.setAttribute("disabled", true);
    b.setAttribute("unavailable", true);
    b.querySelector('.btn-text').innerHTML = 'Fill Out Required Fields';
  }

  disableCartButton(cartButton);
  disableCartButton(stickyCartButton);

  const pf = document.querySelectorAll('.product-personalization');

  pf.forEach(function (p) {
    let pf_inputs = [...p.querySelectorAll('input, select')];
    // let pf_text = p.querySelectorAll('input[type="text"]');
    let pf_acknowledgement = p.querySelector('input[id="personalization-acknowledgment-checkbox"]');


    pf_inputs.forEach(function (p) {
      const handleMask = value => {
        switch (value.getAttribute('placeholder')) {
          case 'MM-DD-YYYY':
            return '99-99-9999';
          case 'YYYY':
            return '9999';
          case 'YYYY-YYYY':
            return '9999-9999';
          case 'MM/DD/YYYY':
            return '99/99/9999';
          case 'MM.DD.YYYY':
            return '99.99.9999';
          case 'MM-DD-YY':
            return '99-99-99';
          case 'MM/DD/YY':
            return '99/99/99';
          case 'MM.DD.YY':
            return '99.99.99';
          default:
        }
      }

      const validateDate = value => {
        const splitValue = value.split(' ');

        if (splitValue.length !== 3) {
          return false;
        }

        const month = splitValue[0];
        if (!isNaN(month)) {
          return false;
        }

        const day = splitValue[1];
        if (!day?.includes(',')) {
          return false;
        }
        const nday = day.substring(0, 2);
        if (nday.length !== 2 || isNaN(nday)) {
          return false;
        }
        const ndayInt = parseInt(nday, 10);
        if (ndayInt > 31) {
          return false;
        }

        const year = splitValue[2];
        if (year.length !== 4 || isNaN(year)) {
          return false;
        }

        return true;
      };

      // handleProfanity(i.value);

      let errorMessage = document.createElement('div');
      errorMessage.classList.add('error-message');
      p.parentNode.insertBefore(errorMessage, p.nextSibling);

      /** Function to disable cart buttons */
      let enableCartButton = b => {
        b.removeAttribute("disabled");
        b.removeAttribute("unavailable");
        b.querySelector('.btn-text').innerHTML = 'Add to Cart';
      }

      let error = false;

      p.addEventListener('input', function () {
        let acknowledgment = false;
        let errorDisplay = p.parentElement.querySelector('.error-message');
        if (p.classList.contains('personalization-date')) {
          if( p.getAttribute('placeholder') == 'Month DD, YYYY' ) {
            error = validateDate(p.value) ? false : true;
          } else {
            if( p.value.match(/[^0-9]/) ) {
              error = true;
            } else {
              let compareDate = p.value.replace(/[0-9]/g, "9");
              if ( compareDate == handleMask(p) ) {
                error = false;
                errorDisplay.innerHTML = '';
              }
            }
          }
          if (error) {
            errorDisplay.innerHTML = 'Incorrect date format';
          } else {
            errorDisplay.innerHTML = '';
          }
        } else if ((p.getAttribute('required', 'true') && p.value == '')) {
          error = true;
          errorDisplay.innerHTML = 'Incorrect text format';
        } else {
          error = false;
          errorDisplay.innerHTML = '';
        }

        if (error) {
          p.classList.add('error');
          pf_acknowledgement.setAttribute("disabled", "true");
          pf_acknowledgement.checked = false;
          disableCartButton(cartButton);
          disableCartButton(stickyCartButton);
        } else {
          let incomplete = false;
          p.classList.remove('error');
          pf_inputs.forEach(function (p) {
            if ((p.getAttribute('required') == 'true' && p.value == '') || p.classList.contains('error')) {
              incomplete = true;
            }
          })
          if (!incomplete) {;
            pf_acknowledgement.removeAttribute("disabled");
          }
        }

        if (!pf_acknowledgement.checked) {
          acknowledgment = false;
          disableCartButton(cartButton);
          disableCartButton(stickyCartButton);
        } else {
          acknowledgment = true;
          enableCartButton(cartButton);
          enableCartButton(stickyCartButton);
        }

        if (!acknowledgment) {
          error = true;
        }
      });
    });
  });
}
